<fui-numeric-control [disabled]="isReadonly" [label]="label" [placeholder]="placeholder" [attr.id]="elementId"
                     [decimals]="decimalPlaces" [(ngModel)]="value" [notation]="'wbo.common.currencyCode' | translate"
                     [control]="formControl">
</fui-numeric-control>
